import styles from "./CareerContent7.module.css";

const CareerContent7 = () => {
  return (
    <div className={styles.numbers}>

      <div className={styles.steps}>
        <div className={styles.divider} />
        <div className={styles.step}>
          <div className={styles.text}>
              <div className={styles.lmstextbox}>

     <div className={styles.boxcontainer}>
         <form>
          <input type="text" placeholder="Full Name" name="name" />
          <input type="text" placeholder="Phone Number" name="name" />
          <input type="text" placeholder="Your School" name="name" />
          <input type="text" placeholder="Role In Your School" name="name" /> 
          <input type="submit" value="Start Learning" />
         </form>      
     </div>

              </div>
          </div>

          <div className={styles.boxcontainerImg}>
          <img
            className={styles.illustrationIcon}
            alt=""
            src="/ttpicon01.svg"
          />
          </div>
        </div>


      </div>
    </div>
  );
};

export default CareerContent7;